const RESET_PATH = '/reset-password';
const RESET_TOKEN_PATTERN = /^[A-Za-z0-9_-]{32,128}$/;

export const capturePasswordResetToken = (): string | null => {
  if (window.location.pathname !== RESET_PATH) {
    return null;
  }

  const fragment = new URLSearchParams(window.location.hash.replace(/^#/, ''));
  const candidate = fragment.get('token');

  if (window.location.hash || window.location.search) {
    window.history.replaceState(window.history.state, document.title, RESET_PATH);
  }

  return candidate && RESET_TOKEN_PATTERN.test(candidate) ? candidate : null;
};
